import React from "react";
import Layout from "../layout";

const AboutUs = () => {
  return (
    <Layout>
      <div className="max-w-7xl mx-auto pt-32 pb-15 px-6">
        {/* Section 1 - Image + Description */}
        <div className="grid md:grid-cols-2 gap-8 items-center mb-20">
          <img
            src="/assets/logo-bloom.jpg"
            alt="FFI BLOOM Store"
            className="w-full h-[300px] object-cover rounded-lg shadow"
          />

          <div>
            <h2 className="text-4xl font-extrabold text-gray-800 mb-4">
              FFI BLOOM
            </h2>

            <p className="text-gray-600 text-lg leading-relaxed text-justify">
              FFI BLOOM is a premium floral provider offering elegant and
              meaningful flower arrangements for every special occasion. We
              provide Flower Bouquets, Bloom Boxes, Vase Arrangements, Standing
              Flowers, and Orchid Gift Arrangements.
            </p>

            <p className="text-gray-600 text-lg leading-relaxed mt-5 text-justify">
              Each arrangement is thoughtfully designed with fresh flowers,
              refined colors, and careful attention to detail to create a
              beautiful and memorable floral experience.
            </p>

            {/* Vision */}
            <div className="mt-8">
              <h3 className="text-2xl font-bold text-gray-800 mb-3">
                Vision
              </h3>

              <p className="text-gray-600 text-lg leading-relaxed text-justify">
                To become a trusted premium florist known for elegant designs,
                quality flowers, and professional service.
              </p>
            </div>

            {/* Mission */}
            <div className="mt-8">
              <h3 className="text-2xl font-bold text-gray-800 mb-3">
                Mission
              </h3>

              <div className="text-gray-600 text-lg leading-relaxed space-y-2 text-justify">
                <p>• Provide fresh, high-quality flowers.</p>
                <p>• Create elegant and meaningful floral designs.</p>
                <p>
                  • Offer arrangements for gifts, celebrations, and special
                  events.
                </p>
                <p>• Deliver professional and personalized service.</p>
              </div>
            </div>

            {/* Products & Services */}
            <div className="mt-8">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">
                Products & Services
              </h3>

              <div className="text-gray-600 text-lg leading-relaxed space-y-4 text-justify">
                <p>
                  Flower Bouquets — Elegant floral arrangements to express
                  love, appreciation, congratulations, and special moments.
                </p>

                <p>
                  Bloom Boxes — Modern and elegant flower arrangements
                  presented in premium boxes, perfect as memorable gifts.
                </p>

                <p>
                  Vase Arrangements — Beautiful floral arrangements designed
                  to enhance interiors with a natural and refined touch.
                </p>

                <p>
                  Standing Flowers — Large-scale floral arrangements for
                  weddings, celebrations, grand openings, and condolences.
                </p>

                <p>
                  Orchid Gift Arrangements — Premium orchid arrangements for
                  exclusive gifts, corporate occasions, and interior
                  decoration.
                </p>
              </div>
            </div>

            <button
              onClick={() => window.scrollTo(0, document.body.scrollHeight)}
              className="mt-6 bg-yellow-700 text-white px-5 py-2 rounded hover:bg-yellow-800 transition"
            >
              View Our Location
            </button>
          </div>
        </div>

        {/* Section 3 - Google Maps */}
        <div className="grid md:grid-cols-2 gap-8 items-center mb-20">
          <div>
            <h2 className="text-3xl font-bold text-gray-800 mb-3">
              Our Location
            </h2>

            <p className="text-gray-700 text-base mb-4">
              FFI BLOOM currently serves customers through our online ordering service. Our location is based in Rawa Belong, West Jakarta.
            </p>

            <p className="text-gray-700 text-base">
              For orders, inquiries, or special requests, please contact us via WhatsApp. Our team will be happy to assist you with your floral needs.
            </p>
          </div>

          <div className="w-full h-[400px]">
            <iframe
              title="FFI BLOOM Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.435722036997!2d106.7784039!3d-6.2061145!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f6db8657b519%3A0x5e46165c8c601f17!2sFlowers%20market%20Rawa%20Belong!5e0!3m2!1sen!2sid!4v1749287556087!5m2!1sen!2sid"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AboutUs;